import styled from 'styled-components';
import { getThemeColor } from 'utils/styled';
import { GRID_AREA_HEADLINE, makeDisableable } from '../styles';

export const Headline = styled.div`
  ${makeDisableable()}
  color: ${getThemeColor('d1')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  grid-area: ${GRID_AREA_HEADLINE};

  // across all of the designs, there are different combinations of styles used for
  // the first and second lines of the Headline.  The space between the two lines is
  // often different, but the entire height of the Headline is usually 40 - 41px.
  // rather than have complex rules for all of the different permutations, set the height
  // to 41 and space evenly.
  height: 41px;

  text-align: left;

  > * {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
`;
